module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "quote _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_c('a', {
    attrs: {
      "id": "u8HtedurPnifSUtgNwRx4u9"
    }
  }), _c('a', {
    attrs: {
      "id": "uuU5PJNCnJLhfPGdXpmUQIH"
    }
  }), _vm._v("BOOK I")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_vm._v("The following crimes occurred between")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_vm._v("7 May, 2000 - 8 September, 2007")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f13eb66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/BookOne.vue
// module id = 78
// module chunks = 0